import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const ContentContext = createContext();
const API = process.env.REACT_APP_BACKEND_URL;

export const ContentProvider = ({ children }) => {
  const { lang } = useLanguage();
  const [contents, setContents] = useState({});
  const [manifest, setManifest] = useState({});

  useEffect(() => {
    fetch(`${API}/api/contents`).then((r) => r.json()).then(setContents).catch(() => {});
    fetch(`${API}/api/assets-manifest`).then((r) => r.json()).then(setManifest).catch(() => {});
  }, []);

  const ct = (key, fallback) => contents[`${lang}.${key}`] || fallback;
  const img = (slot, fallback) => (manifest[slot] ? `${API}/api/assets/${slot}?v=${manifest[slot]}` : fallback);

  return (
    <ContentContext.Provider value={{ ct, img, manifest, setManifest }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
